export { default as GooglePlayDownload } from '../icons-new/components/GooglePlayDownload';
